
import { useState, useEffect } from 'react'

export const useWebsocket = (url, onMessage) => {
    const [state, setState] = useState("connecting")
    const [ws, setWs] = useState()

    useEffect(() => {
        let ws = new WebSocket(url)
        setWs(ws)
        ws.onopen = (event) => {
            setState("open")
        }
        ws.onclose = (event) => {
            setState("close")
        }
        ws.onmessage = (event) => {
            const msg = JSON.parse(event.data)
            console.log("WS Receive:", msg)
            onMessage(msg)
        }
        ws.onerror = (event) => {
            setState("error")
        }
        //exampleSocket.send
        return () => {
            ws.close();
        }

    }, [])

    return [state, (obj) => {
        console.log("WS Sent: ", JSON.stringify(obj))
        ws.send(JSON.stringify(obj))
    }]
}
